module.exports = __webpack_public_path__ + "img/removesessions.17b8b277.svg";